// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Employee profile page (serviceProvider/employees/EmployeesProfile) */
.EmployeesProfile .antd-tabs1 > .ant-tabs-nav {
  margin-block-end: var(--ds-space-3);
}

.EmployeesProfile .antd-tabs1 > .ant-tabs-nav .ant-tabs-nav-wrap {
  padding-inline: var(--ds-space-3);
  background-color: var(--ds-surface);
}

.EmployeesProfile .antd-tabs1 > .ant-tabs-nav .ant-tabs-tab {
  min-height: var(--ds-touch);
}

.EmployeesProfile .employee-profile__summary {
  margin-block-end: var(--ds-space-4);
  text-align: center;
}

.EmployeesProfile .employee-profile__name {
  margin: 0;
  overflow-wrap: anywhere;
}

.EmployeesProfile .employee-profile__details .ant-descriptions-item-content {
  overflow-wrap: anywhere;
}

@media (min-width: 768px) {
  .EmployeesProfile .antd-tabs1 > .ant-tabs-nav .ant-tabs-nav-wrap {
    padding-inline: var(--ds-space-4);
  }
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/employees/EmployeesProfile/Profile.css"],"names":[],"mappings":"AAAA,uEAAuE;AACvE;EACE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,iCAAiC;EACnC;AACF","sourcesContent":["/* Employee profile page (serviceProvider/employees/EmployeesProfile) */\n.EmployeesProfile .antd-tabs1 > .ant-tabs-nav {\n  margin-block-end: var(--ds-space-3);\n}\n\n.EmployeesProfile .antd-tabs1 > .ant-tabs-nav .ant-tabs-nav-wrap {\n  padding-inline: var(--ds-space-3);\n  background-color: var(--ds-surface);\n}\n\n.EmployeesProfile .antd-tabs1 > .ant-tabs-nav .ant-tabs-tab {\n  min-height: var(--ds-touch);\n}\n\n.EmployeesProfile .employee-profile__summary {\n  margin-block-end: var(--ds-space-4);\n  text-align: center;\n}\n\n.EmployeesProfile .employee-profile__name {\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n\n.EmployeesProfile .employee-profile__details .ant-descriptions-item-content {\n  overflow-wrap: anywhere;\n}\n\n@media (min-width: 768px) {\n  .EmployeesProfile .antd-tabs1 > .ant-tabs-nav .ant-tabs-nav-wrap {\n    padding-inline: var(--ds-space-4);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
